import { render, staticRenderFns } from "./document-upload-action.vue?vue&type=template&id=2bf1e000"
import script from "./document-upload-action.ts?vue&type=script&lang=js&external"
export * from "./document-upload-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports